import TencentCloudChat from '@tencentcloud/chat';
import TIMUploadPlugin from 'tim-upload-plugin';

// 模块级别的变量，确保实例只创建一次
const trtcChat: Record<string, any> = { instance: null };
let currentAppId: number | null = null;
const appId = Number(process.env.TENCENT_SDK_APP_ID);

/**
 * 纯函数：获取 SDK 实例（非 hook，可在 store action 中调用）
 */
export function getTrtcChatInstance() {
  // 如果实例已存在且 appId 相同，直接返回
  if (trtcChat.instance && currentAppId === appId) {
    return trtcChat.instance;
  }
  // 如果还未初始化或实例被销毁，创建新实例
  if (!trtcChat.instance && appId) {
    try {
      const options = {
        SDKAppID: appId
      };
      const chat = TencentCloudChat.create(options);
      // 设置 SDK 日志级别
      chat.setLogLevel(0);
      // 注册腾讯云即时通信 Chat 上传插件
      chat.registerPlugin({'tim-upload-plugin': TIMUploadPlugin});
      trtcChat.instance = chat;
      currentAppId = appId;
    } catch (error) {
      console.error('Failed to create TrtcChat instance:', error);
    }
  }
  return trtcChat.instance;
}

export function useTrtcChat() {
  // 确保实例已创建
  getTrtcChatInstance();
  return trtcChat;
}

export default useTrtcChat;

